enum CandidateScreeningRequestStatusEnum {
    Invited = 'INVITED',
    Completed = 'COMPLETED',
    Failed = 'FAILED',
    Expired = 'EXPIRED',
}

export default CandidateScreeningRequestStatusEnum
